var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 101,
    viewBox: "0 0 98 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.35 65.3038L83.96 65.5438L85.35 65.7838L85.6 67.1838L85.84 65.7838L87.23 65.5438L85.84 65.3038L85.6 63.9038L85.35 65.3038Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99048 7.33954L5.94043 7.51953L6.99048 7.70953L7.18048 8.75952L7.36047 7.70953L8.42047 7.51953L7.36047 7.33954L7.18048 6.27954L6.99048 7.33954Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5706 99.5005C85.5466 99.5005 89.5806 95.467 89.5806 90.4914C89.5806 85.5159 85.5466 81.4824 80.5706 81.4824C75.5945 81.4824 71.5605 85.5159 71.5605 90.4914C71.5605 95.467 75.5945 99.5005 80.5706 99.5005Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5704 94.0818C82.5531 94.0818 84.1605 92.4745 84.1605 90.4918C84.1605 88.5091 82.5531 86.9019 80.5704 86.9019C78.5877 86.9019 76.9805 88.5091 76.9805 90.4918C76.9805 92.4745 78.5877 94.0818 80.5704 94.0818Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 99.5005C23.0261 99.5005 27.06 95.467 27.06 90.4914C27.06 85.5159 23.0261 81.4824 18.05 81.4824C13.074 81.4824 9.04004 85.5159 9.04004 90.4914C9.04004 95.467 13.074 99.5005 18.05 99.5005Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 94.0818C20.0327 94.0818 21.64 92.4745 21.64 90.4918C21.64 88.5091 20.0327 86.9019 18.05 86.9019C16.0673 86.9019 14.46 88.5091 14.46 90.4918C14.46 92.4745 16.0673 94.0818 18.05 94.0818Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2002 94.2309H94.2802C96.7802 89.9713 95.0102 85.3918 95.0102 85.3918C95.5302 77.7026 85.2102 76.4527 71.9002 75.2128L61.0702 64.8639C59.7902 63.644 58.1002 62.9641 56.3302 62.9641H19.2802C16.9102 62.9641 14.7102 64.184 13.4602 66.2038L7.86024 75.2128C3.93024 75.8228 3.86022 80.1223 3.40022 83.522C3.14022 85.4118 2.88024 88.2315 2.67024 90.5012C2.49024 92.511 4.07021 94.2309 6.08021 94.2309H7.40022",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6807 94.231H69.9307",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0106 85.4025C90.7406 84.9525 90.4906 81.5925 91.8906 79.5925",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1807 75.2131H71.9006",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86035 75.2131H60.0203",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9707 77.2427V94.1209",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6299 63.0845L62.6599 72.2245",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1699 72.4436H63.1999C64.7299 72.4436 65.9699 73.6836 65.9699 75.2136C65.9699 76.7436 64.7299 77.9836 63.1999 77.9836H60.1699V72.4336V72.4436Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7305 63.1743V93.9812",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5405 79.1028H38.1904",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7006 79.1028H44.1006",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87012 82.0831C8.18012 82.0831 9.25017 78.0031 7.86017 75.2131",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54004 25.178H92.46",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54004 52.3852V25.178H92.46V52.3852",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5696 52.385H2.42969",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4697 44.2556V30.2971H23.6497V44.2556",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0596 30.2971V44.2556",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4697 37.2766H23.6497",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8398 44.2556V30.2971H83.0198V44.2556",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 30.2971V44.2556",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8398 37.2766H83.0198",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9897 44.2559H12.1396",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.35 44.2559H71.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5499 33.9167H43.3398V52.3848H54.5499V33.9167Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5801 52.3852V25.178",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4199 52.3852V25.178",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.96 30.1174H58.93",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5801 41.2061V43.676",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.96 56.0347H58.93",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4201 25.1779L49.0001 9.92944L33.5801 25.1779",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97 26.2977L49 3.5L1 26.2977",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67.04 11.2495V5.24951",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1104 15.5982V5.24927",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7598 5.24976H79.3898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.6dc1211440f1a7e27746da3adb68cc16.svg";
export { ForwardRef as ReactComponent };